export default __webpack_public_path__ + "static/media/000_intro_part1.av1.b1c5fbcd.mp4";